export default {
  status: null,
  category: null,
  dateForOffer: null,
}
